import { render, staticRenderFns } from "./help-center.vue?vue&type=template&id=573af898&"
import script from "./help-center.vue?vue&type=script&lang=ts&"
export * from "./help-center.vue?vue&type=script&lang=ts&"
import style0 from "./help-center.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports